import { Checkbox } from '@/components/Checkbox'
import { FC } from 'react'
import styles from './AcceptPolicy.module.scss'

interface AcceptPolicyProps {
  className?: string
  value: boolean
  onChange: (value: boolean) => void
  error?: string
}
export const AcceptPolicy: FC<AcceptPolicyProps> = ({
  className,
  value,
  onChange,
  error,
}) => {
  return (
    <Checkbox
      className={className}
      value={value}
      onChange={onChange}
      name="acceptPolicy"
      error={error}
      testId="registrationAcceptPolicy"
    >
      <span className={styles.text}>
        Я принимаю{' '}
        <a
          href="/assets/01%20Политика%20в%20отношении%20обработки%20ПДн_Брендсайд.pdf"
          className={styles.link}
          target="_blank"
        >
          условия политики обработки персональных данных
        </a>{' '}
        и{' '}
        <a
          href="/assets/02%20Пользовательское%20соглашение_Брендсайд.pdf"
          className={styles.link}
          target="_blank"
        >
          пользовательского соглашения
        </a>
        , а также даю{' '}
        <a
          href="/assets/03%20Согласие%20на%20обработку%20ПДн_Брендсайд.pdf"
          className={styles.link}
          target="_blank"
        >
          согласие на обработку персональных данных
        </a>{' '}
        и{' '}
        <a
          href="/assets/04%20Согласие%20на%20информационные%20рассылки_Брендсайд.pdf"
          className={styles.link}
          target="_blank"
        >
          согласие на информационные рассылки
        </a>
      </span>
    </Checkbox>
  )
}
